import React, { useEffect } from 'react'

export const getTextEmotionColor = (emotion) => {
  if (["sad", "tired", "lonely"].includes(emotion)) return "text-emotion-blue";
  if (["scared", "angry", "stressed"].includes(emotion)) return "text-emotion-purple";
  if (["grateful", "calm", "happy", "all"].includes(emotion)) return "text-emotion-green";
  return "text-black";
};

export const getBgEmotionColor = (emotion) => {
  if (["sad", "tired", "lonely"].includes(emotion)) return "bg-emotion-blue";
  if (["scared", "angry", "stressed"].includes(emotion)) return "bg-emotion-purple";
  if (["grateful", "calm", "happy", "all"].includes(emotion)) return "bg-emotion-green";
  return "text-black";
};

const EMOJI_MAP = [
  ["sad", "images/emotions/sad.png"],
  ["tired", "images/emotions/tired.png"],
  ["lonely", "images/emotions/lonely.png"],
  ["happy", "images/emotions/happy.png"],
  ["grateful", "images/emotions/grateful.png"],
  ["calm", "images/emotions/calm.png"],
  ["stressed", "images/emotions/stressed.png"],
  ["scared", "images/emotions/scared.png"],
  ["angry", "images/emotions/angry.png"],
  ["all emotions", "images/emotions/all_emotions.png"]
];

export const getEmojiImage = (emotion) => {
  const match = EMOJI_MAP.find(([key]) => key === emotion);
  return match ? match[1] : null;
};

// pie graph
export const emotionOrder = [
    'happy', 'grateful', 'calm',
    'sad', 'tired', 'lonely',
    'stressed', 'scared', 'angry',
];
export const barEmotionOrder = [
  'sad', 'tired', 'lonely',
  'happy', 'grateful', 'calm',
  'stressed', 'scared', 'angry',
];
export const emotionColors = {
  happy: '#4cc68d', grateful: '#4cc68d', calm: '#4cc68d',
  sad: '#5b9cd6', tired: '#5b9cd6', lonely: '#5b9cd6', 
  stressed: '#bd92e4', scared: '#bd92e4', angry: '#bd92e4'
};

export const lineEmotionColors = {
  sad: '#1879ee',
  tired: '#479df4',
  lonely: '#005be2',
  happy: '#4bdd86',
  grateful: '#13bf5d',
  calm: '#00b27a',
  stressed: '#9a80f4',
  scared: '#b67af6',
  angry: '#7a53ee'
};

// pie and bar tooltips
export const bgColors = {
  happy: '#F8FDFA', grateful: '#F8FDFA', calm: '#F8FDFA',
  sad: '#5B9CD60A', tired: '#5B9CD60A', lonely: '#5B9CD60A', 
  stressed: '#FCFAFE', scared: '#FCFAFE', angry: '#FCFAFE'
};
export const getEmotionColor = (emotion) => {
  if (["sad", "tired", "lonely"].includes(emotion)) return "bg-[#F8FBFD]";
  if (["scared", "angry", "stressed"].includes(emotion)) return "bg-[#FCFAFE]";
  if (["grateful", "calm", "happy"].includes(emotion)) return "bg-[#F8FDFA]";
  return "bg-white";
};

//bar graph
export const emotionEmojiImgMapping = {
  "sad": { "alt": "sad-icon", "src": "images/emotions/sad.png" },
  "tired": { "alt": "tired-icon", "src": "images/emotions/tired.png" },
  "lonely": { "alt": "lonely-icon", "src": "images/emotions/lonely.png" },
  "happy": { "alt": "happy-icon", "src": "images/emotions/happy.png" },
  "grateful": { "alt": "grateful-icon", "src": "images/emotions/grateful.png" },
  "calm": { "alt": "calm-icon", "src": "images/emotions/calm.png" },
  "stressed": { "alt": "stressed-icon", "src": "images/emotions/stressed.png" },
  "scared": { "alt": "scared-icon", "src": "images/emotions/scared.png" },
  "angry": { "alt": "angry-icon", "src": "images/emotions/angry.png" }
};
export const getAbbreviation = (emotion) => {
  const abbreviations = {
    "sad": "Sad",
    "tired": "Tird",
    "lonely": "Lnly",
    "happy": "Hpy",
    "grateful": "Grat",
    "calm": "Calm",
    "stressed": "Strs",
    "scared": "Scrd",
    "angry": "Ang"
  };
  return abbreviations[emotion] || emotion.substring(0, 4);
};

//Emotions & What's Helping
export const ACTION_DISPLAY_MAP = {
  "imagine positive things in the future": "Imagine positive things",
  "laugh at something funny": "Laugh at something",
  "remember that difficult times pass": "Remember difficulties pass",
  "remind myself of two good things in my life": "Remember positives",
  "tell myself something nice": "Say nice things to myself",
  "get some sun in my eyes": "Get sun in my eyes",
  "count to ten taking a deep breath each time": "10 deep breaths",
  "listen to music or read": "Enjoy music or reading",
  "politely move away from a distraction": "Walk away calmly",
  "squeeze my fist": "Squeeze my fist",
  "use my growth mindset": "Use growth mindset",
  "think of 3 things that i am grateful for": "Practice gratitude",
  "give someone a compliment": "Compliment",
  "be mindful. be where my feet are": "Be mindful",
  "give someone a high five": "Give a high five",
};

export const challengingEmotions = ["sad", "lonely", "stressed", "angry", "scared"];

export const alertTypeOptions = [
  { label: "All Types (Word and Emotion)", value: "all" },
  { label: "Word Alerts", value: "word" },
  { label: "Emotion Alerts", value: "emotion" }
];

export const alertStatusOptions = [
  { label: "All Alerts", value: "all" },
  { label: "Unseen Alerts", value: "unseen" },
  { label: "Seen Alerts", value: "seen" }
];